import { createSelector } from 'reselect'

const getAlerts = state => state.alerts

export const getAlertsData = createSelector([getAlerts], state => (state ? state.data : null))
